import {MODAL_HIDE, MODAL_SHOW} from "../actions/ModalActions";

const initialState = {};

export default function ModalReducer(state = initialState, action) {
    switch (action.type) {
        case MODAL_SHOW:
            return {
                [action.payload]: true,
            }

        case MODAL_HIDE:
            return {}
    }

    return state
}